import { yupResolver } from '@hookform/resolvers/yup';
import { Checkbox, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import React, { useContext, useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useUserById } from 'hooks';
import { AdministrationAddSortingCenterUserRoleForm, SortingCenter, SortingCenterUserRole } from 'types';
import { transformObjectId } from 'services/apiPlatformTransformer';
import { AppContext } from 'context';
import { useStyles } from './styles';
import { AdministrationUserCreateStep4Schema } from './Step1.yup';
import { AdministrationUserCreateStepProps } from './types';

interface ListItemSortingCenterProps {
  sortingCenter: SortingCenter;
}

export const Step1: React.FC<AdministrationUserCreateStepProps> = ({
  onSubmit,
  formName,
  previousStepData,
  setFormContext,
}) => {
  const context = useContext(AppContext);
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'administration.users.create' });
  const schema = useMemo(() => AdministrationUserCreateStep4Schema(t), [t]);

  const sortingCenters = context.getSortingCenters?.();
  const eligibleSortingCenterChild: SortingCenter[] = [];
  sortingCenters?.map((sortingCenter: SortingCenter) => {
    sortingCenter.childrenSortingCenter?.map(sortingCenterChild => {
      eligibleSortingCenterChild.push(sortingCenterChild);
      return null;
    });
    return null;
  });

  const user = useUserById(previousStepData.userId ? previousStepData.userId : '');

  const sortingCenterUserRoleInitial: any[] = [];
  if (user) {
    user.sortingCenterUserRoles.map((sortingCenterUserRole: SortingCenterUserRole, index: number) => {
      const sortingCenterUserRoleId = parseInt(transformObjectId(sortingCenterUserRole.sortingCenter), 10);
      sortingCenterUserRoleInitial[sortingCenterUserRoleId] = true;
      return null;
    });
  }

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<AdministrationAddSortingCenterUserRoleForm>({
    mode: 'onSubmit',
    defaultValues: previousStepData,
    resolver: yupResolver(schema),
  });

  const ListItemSortingCenter: React.FC<ListItemSortingCenterProps> = ({ sortingCenter }) => {
    const sortingCenterId = parseInt(transformObjectId(sortingCenter), 10);
    return (
      <div className={classes.listItemContainer}>
        <ListItem>
          <ListItemText className={classes.itemLabel}>
            <Typography>
              {sortingCenter.name} - <span className={classes.primary}>{sortingCenter.code}</span>
            </Typography>
          </ListItemText>
          <ListItemIcon>
            <Controller
              name={`sortingCenters.${sortingCenterId}`}
              control={control}
              render={({ field: { ref, onChange, value, ...inputProps }, fieldState }) => (
                <Checkbox
                  id={`sortingCenters.${sortingCenterId}`}
                  color={'primary'}
                  checked={!!value || sortingCenterUserRoleInitial[sortingCenterId]}
                  value={!!value || sortingCenterUserRoleInitial[sortingCenterId]}
                  onChange={onChange}
                  inputRef={ref}
                  disabled={sortingCenterUserRoleInitial[sortingCenterId]}
                  {...inputProps}
                />
              )}
            />
          </ListItemIcon>
        </ListItem>
      </div>
    );
  };

  const [saveFormContext, setSaveFormContext] = useState(false);
  if (!saveFormContext && user) {
    setFormContext({
      user: user,
      sortingCentersInitial: sortingCenterUserRoleInitial,
    });
    setSaveFormContext(true);
  }

  return (
    <form className={classes.form} id={formName} onSubmit={handleSubmit(onSubmit)}>
      <br />
      <br />
      <div className={classes.fieldHeader}>
        <Typography
          className={errors && errors.sortingCenters ? classes.sortingCentersErrors : classes.sortingCentersSuccess}
        >
          {t('sortingCenterList')}
        </Typography>
      </div>
      <div className={classes.divScroll}>
        {eligibleSortingCenterChild
          ? eligibleSortingCenterChild.map((sortingCenter: SortingCenter, index) => (
              <ListItemSortingCenter key={index} sortingCenter={sortingCenter} />
            ))
          : ''}
      </div>
      <div className={classes.treeBottom} />
    </form>
  );
};
